import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/index.css";
import Nav from "@/components/jf/Nav";
import Footer from "@/components/jf/Footer";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import StoryPage from "@/pages/StoryPage";
import CraftPage from "@/pages/CraftPage";
import SpacesPage from "@/pages/SpacesPage";
import AmbaariPage from "@/pages/AmbaariPage";
import BookPage from "@/pages/BookPage";
import ProductPage from "@/pages/ProductPage";
import AdminPage from "@/pages/AdminPage";
import VisitPage from "@/pages/VisitPage";
import PaymentResultPage from "@/pages/PaymentResultPage";
import WhatsAppButton from "@/components/jf/WhatsAppButton";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

function App() {
  const [bookingProduct, setBookingProduct] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const onBook = (name) => setBookingProduct(name);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div data-testid="app-root" className="bg-ivory text-ink font-body">
        <div className="grain-overlay" />
        <Nav />
        <Routes>
          <Route path="/" element={<HomePage onBook={onBook} selectedProduct={bookingProduct} />} />
          <Route path="/shop" element={<ShopPage onBook={onBook} />} />
          <Route path="/product/:id" element={<ProductPage onBook={onBook} />} />
          <Route path="/visit" element={<VisitPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/payment/success" element={<PaymentResultPage type="success" />} />
          <Route path="/payment/cancel" element={<PaymentResultPage type="cancel" />} />
          <Route path="/story" element={<StoryPage />} />
          <Route path="/craft" element={<CraftPage />} />
          <Route path="/spaces" element={<SpacesPage />} />
          <Route path="/ambaari" element={<AmbaariPage />} />
          <Route path="/book" element={<BookPage selectedProduct={bookingProduct} />} />
          <Route path="*" element={<HomePage onBook={onBook} selectedProduct={bookingProduct} />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#38100B", color: "#F6F0E4", border: "1px solid #C6A15B" } }} />
      </div>
    </BrowserRouter>
  );
}

export default App;
